var ye = Object.defineProperty;
var pe = (e, r, t) => r in e ? ye(e, r, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[r] = t;
var y = (e, r, t) => pe(e, typeof r != "symbol" ? r + "" : r, t);
import { inject as b, defineComponent as J, onMounted as te, onUnmounted as D, openBlock as re, createElementBlock as oe, createElementVNode as T, toDisplayString as E, normalizeClass as me, readonly as _, ref as h, watch as Y, computed as O, unref as he, renderSlot as G } from "vue";
import x from "decimal.js";
import { DateOnly as ne } from "@hantera/design-system";
const Q = {
  info(...e) {
    process.env.NODE_ENV === "development" && console.log("[hantera]", ...e);
  },
  debug(...e) {
    process.env.NODE_ENV === "development" && console.debug("[hantera]", ...e);
  },
  warn(...e) {
    process.env.NODE_ENV === "development" && console.warn("[hantera]", ...e);
  },
  err(...e) {
    process.env.NODE_ENV === "development" && console.error("[hantera]", ...e);
  }
}, ve = {
  sidebar: a("workspace.sidebar")
}, ge = {
  sidebar: a("orderView.sidebar"),
  sidebarCustomer: a("orderView.sidebarCustomer"),
  toolbars: {
    deliveries: a("orderView.toolbars.delivery"),
    invoices: a("orderView.toolbars.invoices"),
    payments: a("orderView.toolbars.payments"),
    timeline: a("orderView.toolbars.timeline")
  },
  delivery: {
    header: a("orderView.delivery.header"),
    footer: a("orderView.delivery.footer")
  },
  orderLine: {
    details: a("orderView.orderLine.details"),
    extras: a("orderView.orderLine.extras")
  },
  shippingLine: {
    extras: a("orderView.shippingLine.extras")
  },
  payment: {
    header: a("orderView.payment.header"),
    details: a("orderView.payment.details"),
    footer: a("orderView.payment.footer")
  }
}, be = {
  legacyOrder: {
    details: {
      beforeSummary: a("legacyOrder.details.beforeSummary"),
      afterSummary: a("legacyOrder.details.belowSummary"),
      beforeNotes: a("legacyOrder.details.beforeNotes"),
      afterNotes: a("legacyOrder.details.afterNotes"),
      beforeAddress: a("legacyOrder.details.beforeAddress"),
      afterAddress: a("legacyOrder.details.afterAddress"),
      beforeCustomer: a("legacyOrder.details.beforeCustomer"),
      afterCustomer: a("legacyOrder.details.afterCustomer")
    },
    delivery: {
      header: a("legacyOrder.delivery.header"),
      footer: a("legacyOrder.delivery.footer"),
      details: a("legacyOrder.delivery.details"),
      rows: a("legacyOrder.delivery.rows"),
      contextMenu: a("legacyOrder.delivery.contextMenu"),
      rowDetails: a("legacyOrder.delivery.rowDetails")
    },
    contextMenu: a("legacyOrder.contextMenu"),
    rmas: {
      first: a("legacyOrder.rmas.first")
    },
    rma: {
      details: a("legacyOrder.rma.details"),
      footer: a("legacyOrder.rma.footer"),
      rows: a("legacyOrder.rma.rows"),
      contextMenu: a("legacyOrder.rma.contextMenu"),
      row: a("legacyOrder.rma.row"),
      rowDetails: a("legacyOrder.rma.rowDetails")
    },
    invoices: {
      first: a("legacyOrder.invoices.first"),
      last: a("legacyOrder.invoices.last")
    },
    invoice: {
      header: a("legacyOrder.invoice.header"),
      footer: a("legacyOrder.invoice.footer"),
      rows: a("legacyOrder.invoice.rows"),
      contextMenu: a("legacyOrder.invoice.contextMenu")
    }
  },
  legacyPayment: {
    contextMenu: a("legacyPayment.contextMenu")
  }
}, we = {
  inventory: {
    editor: a("inventoryEditor.inventory")
  }
}, _e = {
  channel: {
    editor: a("channelEditor.channel")
  },
  country: {
    editor: a("channelEditor.country")
  }
}, Se = {
  settings: a("appSettings.settings")
}, Oe = $("standardServices.shippingProductsService"), Ce = $("standardServices.productsService"), $e = {
  /**
   * Allows services to extend the foundational order view graph query with
   * additional fields and navigations. Extensions are append-only: existing
   * fields and navigations are never removed. This lets apps surface their own
   * typed fields (including registry-defined dynamic fields) on the order view
   * state instead of reading and coercing values from the dynamic bag manually.
   */
  queryExtensionProvider: $("standardServices.orderView.queryExtensionProvider"),
  /**
   * Allows services to extend the details tabs of the standard order view
   */
  tabProvider: $("standardServices.orderView.tabProvider"),
  /**
   * Allows services to contribute context menu items to delivery and payment
   * panels in the order view. Implement only the methods relevant to the app.
   */
  contextMenuProvider: $("standardServices.orderView.contextMenuProvider"),
  /**
   * Allows services to react to events occurring in the standard order view,
   * such as the order being saved.
   */
  eventsProvider: $("standardServices.orderView.eventsProvider"),
  /**
   * Allows services to contribute options to the "New payment" dropdown in the
   * payments tab of the order view.
   */
  paymentActionsProvider: $("standardServices.orderView.paymentActionsProvider")
}, Le = {
  /**
   * Allows services to extend the details tabs of the legacy order view
   */
  tabProvider: $("standardServices.legacyOrderView.tabProvider")
}, Te = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  legacyOrderView: Le,
  orderView: $e,
  productsService: Ce,
  shippingProductsService: Oe
}, Symbol.toStringTag, { value: "Module" }));
function a(e) {
  return {
    key: e
  };
}
function $(e) {
  return {
    key: e
  };
}
function xe(e) {
  const r = b("$portal_appComponentContext");
  if (r === void 0) {
    const t = `Expected component context for '${e.key}' but found none`;
    throw Q.err(t), new Error(t);
  }
  return r(e).context;
}
const Ot = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  appSettingsSlots: Se,
  channelEditorSlots: _e,
  componentContext: xe,
  defineService: $,
  defineSlot: a,
  inventoryEditorSlots: we,
  legacySlots: be,
  orderViewSlots: ge,
  standardServices: Te,
  workspaceSlots: ve
}, Symbol.toStringTag, { value: "Module" })), Ae = Symbol("context"), Re = Symbol("appContext"), je = Symbol("backendApi"), ke = Symbol("host"), Ct = Symbol("legacyMode"), $t = Symbol("legacy-order"), Lt = Symbol("legacy-invoice"), Tt = Symbol("legacy-rma"), xt = Symbol("legacy-rma-row"), Fe = Symbol("processes"), Me = {
  orderView: Symbol("context-order")
};
function At() {
  return {
    ...b(Ae, {})
  };
}
function Rt() {
  return {
    ...b(Re, {})
  };
}
function jt() {
  return {
    ...b(ke, {})
  };
}
function ie() {
  return {
    ...b(je, {})
  };
}
function kt(e) {
  return b("$portal_phraseLookup", {})(e);
}
function Ee() {
  return b(
    "$portal_enums",
    {}
  );
}
function De() {
  return b(
    "$portal_graphMeta",
    {}
  );
}
const Pe = { class: "confirm-dialog" }, Ne = { class: "confirm-dialog__text" }, Ve = { class: "confirm-dialog__buttons" }, Qe = /* @__PURE__ */ J({
  __name: "ConfirmDialog",
  props: {
    message: {},
    confirmLabel: {},
    cancelLabel: {},
    danger: { type: Boolean },
    onConfirm: { type: Function }
  },
  setup(e) {
    const r = e;
    te(() => {
      document.addEventListener("keydown", t);
    }), D(() => {
      document.removeEventListener("keydown", t);
    });
    function t(o) {
      o.key === "Enter" && r.onConfirm(!0);
    }
    return (o, n) => (re(), oe("div", Pe, [
      T("div", Ne, E(e.message), 1),
      T("div", Ve, [
        T("button", {
          class: me(e.danger ? "btn-danger" : "btn-primary"),
          onClick: n[0] || (n[0] = (i) => e.onConfirm(!0))
        }, E(e.confirmLabel), 3),
        T("button", {
          onClick: n[1] || (n[1] = (i) => e.onConfirm(!1))
        }, E(e.cancelLabel), 1)
      ])
    ]));
  }
}), qe = { class: "alert-dialog" }, ze = { class: "alert-dialog__text" }, Ie = { class: "alert-dialog__buttons" }, Ke = /* @__PURE__ */ J({
  __name: "AlertDialog",
  props: {
    message: {},
    confirmLabel: {},
    onConfirm: { type: Function }
  },
  setup(e) {
    const r = e;
    te(() => {
      document.addEventListener("keydown", t);
    }), D(() => {
      document.removeEventListener("keydown", t);
    });
    function t(o) {
      o.key === "Enter" && r.onConfirm();
    }
    return (o, n) => (re(), oe("div", qe, [
      T("div", ze, E(e.message), 1),
      T("div", Ie, [
        T("button", {
          class: "btn-primary",
          onClick: n[0] || (n[0] = (i) => e.onConfirm())
        }, E(e.confirmLabel), 1)
      ])
    ]));
  }
});
function Ft() {
  const e = b("$portal_addDialog", {})();
  return {
    /**
     * Creates a dialog that can be opened and closed multiple times.
     * @param label 
     * @param component 
     * @param showClose 
     * @param props 
     * @returns 
     */
    add(r, t, o, n, i) {
      const s = e(r, t, o, n, !1, i);
      return D(() => {
        s.destroy();
      }), {
        open: s.open,
        openModal: s.openModal,
        close: s.close
      };
    },
    /**
     * Opens a dialog that will be destroyed when closed.
     * @param label 
     * @param component 
     * @param showClose 
     * @param props 
     * @returns 
     */
    open(r, t, o, n, i) {
      const s = e(r, t, o, n, !0, i);
      return s.open(), {
        close: s.close
      };
    },
    /**
     * Opens a dialog that will be destroyed when closed.
     * @param label 
     * @param component 
     * @param showClose 
     * @param props 
     * @returns 
     */
    openModal(r, t, o, n, i) {
      const s = e(r, t, o, n, !0, i);
      return s.openModal(), {
        close: s.close
      };
    },
    /**
     * Displays a confirmation dialog and returns a promise that resolves when the dialog is confirmed.
     */
    confirm(r, t, o, n, i) {
      let s = !1;
      const l = new Promise((m) => {
        const p = e(
          t ?? "Confirm Action",
          Qe,
          !1,
          {
            message: r,
            confirmLabel: o ?? "Yes",
            cancelLabel: n ?? "No",
            danger: i,
            onConfirm(v) {
              s = !0, p.close(), m(v);
            }
          },
          !0,
          void 0,
          () => {
            s || m(!1);
          }
        );
        p.openModal();
      });
      return l.then(() => {
        s = !0;
      }), l;
    },
    /**
    * Displays an alert dialog and returns a promise that resolves when the dialog is confirmed.
    */
    alert(r, t, o) {
      let n = !1;
      const i = new Promise((s) => {
        const l = e(
          t ?? "Alert",
          Ke,
          !1,
          {
            message: r,
            confirmLabel: o ?? "OK",
            onConfirm(m) {
              n = !0, l.close(), s();
            }
          },
          !0,
          void 0,
          () => {
            n || s();
          }
        );
        l.openModal();
      });
      return i.then(() => {
        n = !0;
      }), i;
    }
  };
}
var se = /* @__PURE__ */ ((e) => (e[e.localized = 0] = "localized", e[e.symbol = 1] = "symbol", e[e.code = 2] = "code", e[e.none = 3] = "none", e))(se || {});
const X = {};
function R() {
  const e = document.documentElement.dataset.formatting ?? navigator.language;
  let r = X[e];
  if (!r) {
    const t = {}, o = {};
    r = {
      getCurrencyFormatter(n, i) {
        let s;
        switch (i ?? 3) {
          case 0:
            s = "symbol";
            break;
          case 1:
            s = "narrowSymbol";
            break;
          default:
            s = "code";
            break;
        }
        const l = n + s;
        let m = t[l];
        return m || (m = new Intl.NumberFormat(e, {
          style: "currency",
          currency: n,
          currencyDisplay: s
        }), t[l] = m), m;
      },
      getNoCurrencyFormatter(n) {
        let i = o[n];
        if (!i) {
          const s = ae(n);
          i = Intl.NumberFormat(e, {
            minimumFractionDigits: s,
            maximumFractionDigits: s
          }), o[n] = i;
        }
        return i;
      },
      percentFormatter: new Intl.NumberFormat(e, {
        style: "percent"
      }),
      numberFormatter: new Intl.NumberFormat(e, {}),
      dateTimeFormatter: new Intl.DateTimeFormat(e, {
        year: "numeric",
        month: "numeric",
        day: "numeric",
        hour: "numeric",
        minute: "numeric",
        second: "numeric"
      }),
      dateFormatter: new Intl.DateTimeFormat(e, {
        year: "numeric",
        month: "numeric",
        day: "numeric"
      }),
      timeFormatter: new Intl.DateTimeFormat(e, {
        hour: "numeric",
        minute: "numeric",
        second: "numeric"
      })
    }, X[e] = r;
  }
  return r;
}
const Ue = /^[0-9]$/;
function Je(e) {
  return Ue.test(e);
}
function ae(e) {
  switch (e.toUpperCase()) {
    case "JPY":
      return 0;
    default:
      return 2;
  }
}
function Be(e, r, t = 3) {
  typeof e == "number" && (e = new x(e));
  const { getCurrencyFormatter: o, getNoCurrencyFormatter: n } = R();
  return t === 3 ? n(r).format(e.toNumber()) : o(r, t).format(e.toNumber());
}
function He(e) {
  return R().percentFormatter.format(e instanceof x ? e.toNumber() : e);
}
function le(e) {
  return R().numberFormatter.format(e instanceof x ? e.toNumber() : e);
}
function We(e) {
  return e && new Intl.DisplayNames([document.documentElement.lang ?? navigator.language], { type: "region" }).of(e.toUpperCase()) || "";
}
function Ye(e) {
  return typeof e == "string" && (e = new Date(e)), !e || e.getFullYear() === 1 ? "" : R().dateTimeFormatter.format(e);
}
function Ge(e) {
  return e instanceof ne && (e = e.toDate()), typeof e == "string" && (e = new Date(e)), !e || e.getFullYear() === 1 ? "" : R().dateFormatter.format(e);
}
function Xe(e) {
  return typeof e == "string" && (e = new Date(e)), !e || e.getFullYear() === 1 ? "" : R().timeFormatter.format(e);
}
function Ze(e) {
  e = e.replaceAll("−", "-"), e = e.replaceAll(" ", "");
  var r = 1.1.toLocaleString().substring(1, 2), t = 1e3.toLocaleString().substring(1, 2);
  return t.charCodeAt(0) === 160 ? t = " " : e = e.replaceAll(" ", ""), Je(t) || (e = e.replaceAll(t, "")), e = e.replace(r, "."), e;
}
const et = /\{(.+?)\}/gi;
function tt(e, r) {
  return r || (r = {}), e.replace(et, (t, o) => {
    if (r) {
      let n = r[o];
      if (n != null)
        return n.toString();
    }
    return `{${o.toLowerCase()}}`;
  });
}
const Mt = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  CurrencyDisplay: se,
  cleanNumberInput: Ze,
  country: We,
  currency: Be,
  date: Ge,
  dateTime: Ye,
  getCurrencyDecimals: ae,
  number: le,
  percent: He,
  string: tt,
  time: Xe
}, Symbol.toStringTag, { value: "Module" })), rt = /\{(.+?)\}/gi;
function ot(e, r) {
  return r || (r = {}), e.replace(rt, (t, o) => {
    if (r) {
      let n = r[o];
      if (typeof n == "number" || x.isDecimal(n))
        return le(n);
      if (typeof n < "u")
        return n.toString();
    }
    return `{${o.toLowerCase()}}`;
  });
}
function ue(e, r, t) {
  const o = r.length > 0 ? r[0] : "en";
  let n = e[o];
  for (let i = 0; i < t.length; i++) {
    const s = t[i];
    if (n != null && n[s])
      n = n[s];
    else
      return Q.debug(`Missing translation for ${o} (${t.join(".")})`), r.length > 0 || o !== "en" ? ue(e, r.slice(1), t) : void 0;
  }
  if (typeof n == "string")
    return n;
}
function nt(e) {
  const r = b("$portal_localization"), t = (o, n) => {
    if (!o) return o;
    e && (o = `${e}.${o}`);
    const i = [document.documentElement.lang, ...navigator.languages.map((m) => m.substring(0, 2))], s = o.trim().split("."), l = ue(r, i, s);
    return typeof l == "string" ? ot(l, n) : o;
  };
  return t.availableLanguages = Object.keys(r || {}), t;
}
function Et() {
  return {
    ...b(Fe, {})
  };
}
function Dt() {
  const e = b(Me.orderView);
  if (!e)
    throw new Error("Order not found in context");
  return e;
}
function Pt() {
  const e = b("$portal_eventsService");
  if (!e)
    return {
      available: !1,
      state: _(h({ status: "disconnected" })),
      subscribe: () => (console.warn("Events service not available"), () => {
      })
    };
  const r = [];
  return D(() => {
    r.forEach((t) => t()), r.length = 0;
  }), {
    available: !0,
    state: e.state,
    subscribe: (t) => {
      const o = e.subscribe(t);
      return r.push(o), () => {
        o();
        const n = r.indexOf(o);
        n >= 0 && r.splice(n, 1);
      };
    }
  };
}
function it() {
  const e = b("$portal_liveQueryService");
  if (!e)
    return {
      available: !1,
      query: (t) => ({
        nodes: _(h([])),
        loading: _(h(!1)),
        totalCount: _(h(null)),
        capped: _(h(!1)),
        revision: _(h(0)),
        error: _(h(null)),
        dispose: () => {
        }
      }),
      queryTable: (t) => ({
        columns: _(h([])),
        rows: _(h([])),
        loading: _(h(!1)),
        totalCount: _(h(null)),
        capped: _(h(!1)),
        revision: _(h(0)),
        error: _(h(null)),
        dispose: () => {
        }
      })
    };
  const r = [];
  return D(() => {
    r.forEach((t) => t()), r.length = 0;
  }), {
    available: !0,
    query: (t) => {
      const o = e.query(t);
      return r.push(o.dispose), o;
    },
    queryTable: (t) => {
      const o = e.queryTable(t);
      return r.push(o.dispose), o;
    }
  };
}
function st() {
  const e = b("$portal_registryStore");
  if (!e)
    throw new Error("Registry store not provided. Ensure the portal client initializes the registry store.");
  return {
    get: e.get.bind(e),
    list: e.list.bind(e),
    set: e.set.bind(e),
    clear: e.clear.bind(e),
    index: e.index.bind(e),
    invalidate: e.invalidate.bind(e),
    async getInventory(r) {
      return await e.get(`inventories/${r}`);
    },
    async listInventories() {
      const r = await e.list("inventories", !0), t = {};
      for (const [o, n] of Object.entries(r)) {
        const i = o.split("/").pop();
        t[i] = n;
      }
      return t;
    },
    async getChannel(r) {
      return await e.get(`channels/${r}`);
    },
    async listChannels() {
      const r = await e.list("channels", !0), t = {};
      for (const [o, n] of Object.entries(r)) {
        const i = o.split("/").pop();
        t[i] = n;
      }
      return t;
    }
  };
}
let L = null, K = null;
async function Z() {
  return L || (K || (K = st().list("locales", !0).then((r) => (L = Object.entries(r).map(([t, o]) => {
    const n = typeof o == "string" ? JSON.parse(o) : o;
    return {
      key: t.split("/").pop(),
      label: (n == null ? void 0 : n.label) || "",
      language: (n == null ? void 0 : n.language) || ""
    };
  }), L)).catch(() => (L = [], L))), K);
}
function ee(e) {
  return e.split("-")[0].split("_")[0].toLowerCase();
}
function at(e, r) {
  if (!e) return "";
  if (typeof e == "string") return e;
  const t = ee(document.documentElement.lang ?? navigator.language ?? "en");
  for (const o of r)
    if (ee(o.language) === t && e[o.key] !== void 0)
      return e[o.key];
  return e.default ?? Object.values(e)[0] ?? "";
}
function Nt() {
  const e = h(L ?? []);
  L || Z().then((t) => {
    e.value = t;
  });
  function r(t) {
    return at(t, e.value);
  }
  return {
    resolve: r,
    locales: e,
    loadLocales: Z
  };
}
const Vt = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null
}, Symbol.toStringTag, { value: "Module" })), U = 1e4;
function Qt(e, r, t, o) {
  const { graph: n } = ie(), i = De(), s = Ee(), l = it(), m = nt();
  return new lt(
    n,
    i,
    s,
    l,
    m,
    e,
    r,
    t,
    o ?? {}
  );
}
class lt {
  constructor(r, t, o, n, i, s, l, m, p) {
    y(this, "_rows", h([]));
    y(this, "rows", O(() => this._rows.value));
    y(this, "_isLoading", h(!1));
    y(this, "isLoading", O(() => this._isLoading.value));
    y(this, "_allLoaded", h(!1));
    y(this, "allLoaded", O(() => this._allLoaded.value));
    y(this, "_totalCount", h(0));
    y(this, "totalCount", O(() => ({
      count: this._totalCount.value,
      cap: U
    })));
    y(this, "_errors", h());
    y(this, "errors", O(() => this._errors.value));
    y(this, "columns", O(() => {
      return this.columnState.value.map((t) => {
        try {
          const o = t.queryPath.join("."), n = r(o, t.field, this.query.value);
          if (!n)
            return;
          const i = this.getNodeMeta(t.queryPath, this.rootEdges.value);
          if (!i)
            return;
          const s = i.fields[t.field];
          if (!s)
            return;
          let l, m = !1, p = !1, v = s.valueType, A = !1;
          v.type === "array" && (A = !0, v = v.itemType), v.type === "enum" ? (s.filter.type === "enums" && (m = !0), p = !A, l = {
            type: "enum",
            isArray: A,
            enums: this.enums.valueSets(i.name, s.name).value
          }) : v.type === "scalar" && v.scalarType === "instant" ? s.filter.type === "instantRange" ? (m = !0, p = !0, l = {
            type: "instant",
            min: s.filter.min
          }) : l = {
            type: "instant"
          } : v.type === "scalar" && v.scalarType === "decimal" ? s.filter.type === "numericRange" ? (m = !0, p = !0, l = {
            type: "number",
            min: s.filter.min,
            max: s.filter.max
          }) : l = {
            type: "number"
          } : v.type === "scalar" && v.scalarType === "boolean" ? s.filter.type === "boolean" ? (m = !0, p = !0, l = {
            type: "boolean"
          }) : l = {
            type: "boolean"
          } : (s.filter.type !== "none" && (m = !0, (v.type !== "scalar" || v.scalarType !== "boolean") && (p = !0)), l = {
            type: "text",
            isArray: A
          }), t.queryPath.length > 1 && (p = !1);
          const j = this.tableHeaders.value.findIndex((P) => P === o + "." + t.field), k = o + "@" + t.field;
          let F;
          return this.state.value.orderBy && this.state.value.orderBy.queryPath.join(".") === t.queryPath.join(".") && this.state.value.orderBy.field === t.field && (F = this.state.value.orderBy.direction), {
            key: k,
            label: n.label,
            valueIdx: j,
            canFilter: m,
            canSort: p,
            size: t.size,
            filters: this.state.value.filters[k] ?? [],
            sort: F,
            values: l
          };
        } catch (o) {
          Q.err("Failed to handle column", t, o);
          return;
        }
      }).filter((t) => !!t);
      function r(t, o, n, i = "") {
        if (i += (i ? "." : "") + n.edge, i === t) {
          for (const s of n.availableFields)
            if (s.field === o)
              return s;
          return;
        }
        if (n.navigations)
          for (const s of n.navigations) {
            const l = r(t, o, s, i);
            if (l)
              return l;
          }
      }
    }));
    y(this, "abortController");
    y(this, "lastCursor");
    y(this, "currentQuery");
    y(this, "currentQueryJson");
    y(this, "rootEdges", O(() => Object.keys(this.graphMeta).reduce((r, t) => {
      const o = this.graphMeta[t];
      return r[o.rootEdgeName] = {
        node: t,
        cardinality: "many"
      }, r;
    }, {})));
    y(this, "tableHeaders", h([]));
    y(this, "_live");
    y(this, "_capped", h(!1));
    y(this, "activeTable");
    y(this, "stopLiveWatch");
    y(this, "liveAvailable", O(() => this.liveQueries.available));
    y(this, "isLive", O(() => this._live.value));
    y(this, "capped", O(() => this._capped.value));
    y(this, "endMessage", O(() => {
      if (!(!this._capped.value || !this._live.value))
        return {
          text: this.t("graphDataProvider.liveCapped.message", { count: this._totalCount.value }),
          actions: [{
            label: this.t("graphDataProvider.liveCapped.loadAll"),
            onClick: () => {
              this._live.value = !1;
            }
          }]
        };
    }));
    y(this, "columnOptions", O(() => {
      const r = {
        setLabel: "default",
        columns: []
      };
      return t(this.query.value), [r];
      function t(o, n) {
        n || (n = ""), n += o.edge;
        for (const i of o.availableFields)
          r.columns.push({
            key: n + "@" + i.field,
            label: i.label ?? i.field
          });
        for (const i of o.navigations ?? [])
          t(i, n + ".");
      }
    }));
    this.graph = r, this.graphMeta = t, this.enums = o, this.liveQueries = n, this.t = i, this.query = s, this.columnState = l, this.state = m, this.options = p, this._live = this.options.live ?? h(!1), Y([this.query, this.state, this._live], async () => {
      await this.refreshInternal();
    }, { deep: !0 });
  }
  async refresh() {
    await this.refreshInternal(!0);
  }
  /**
   * Constructs the current query as computed by the provider including any active filters
   */
  getCurrentQuery() {
    return this.buildQuery(this.query.value, this.rootEdges.value, void 0, !0);
  }
  async refreshInternal(r = !1) {
    if (this._live.value) {
      this.refreshLive(r);
      return;
    }
    this.disposeLiveQuery(), this.abortController && this.abortController.abort(), this.abortController = new AbortController(), this._errors.value = [];
    try {
      const t = this.buildQuery(this.query.value, this.rootEdges.value);
      if (!t) {
        this._totalCount.value = 0, this._rows.value = [], this._allLoaded.value = !0, this.tableHeaders.value = [];
        return;
      }
      t.limit = 100;
      const o = JSON.stringify(t);
      if (o === this.currentQueryJson && !r)
        return;
      this.currentQueryJson = o, this.currentQuery = t, this._isLoading.value = !0;
      const n = await this.graph.queryTable(t, this.abortController.signal);
      this.tableHeaders.value = n.headers, this._totalCount.value = (n.totalCount ?? new x(0)).toNumber(), this._rows.value = n.rows.map(
        (i) => ({
          key: this.rowKey(this.toRecord(i)),
          values: i
        })
      ), this.lastCursor = n.cursors.last, n.totalCount !== void 0 ? this._allLoaded.value = n.totalCount.lt(U) && n.totalCount.eq(n.rows.length) : this._allLoaded.value = n.rows.length < 100;
    } catch (t) {
      this._totalCount.value = 0, this._rows.value = [], this._errors.value = t, this._allLoaded.value = !0;
    } finally {
      this.abortController = void 0, this._isLoading.value = !1;
    }
  }
  refreshLive(r = !1) {
    var n;
    this.abortController && (this.abortController.abort(), this.abortController = void 0), this._errors.value = [];
    const t = this.buildQuery(this.query.value, this.rootEdges.value);
    if (!t) {
      this._totalCount.value = 0, this._rows.value = [], this._allLoaded.value = !0, this.tableHeaders.value = [], this._capped.value = !1, this.disposeLiveQuery();
      return;
    }
    t.limit = void 0;
    const o = JSON.stringify(t);
    o === this.currentQueryJson && !r || (this.currentQueryJson = o, this.currentQuery = t, this._isLoading.value = !0, this.disposeLiveQuery(), this.activeTable = this.liveQueries.queryTable(t), (n = this.stopLiveWatch) == null || n.call(this), this.stopLiveWatch = Y(
      () => [
        this.activeTable.columns.value,
        this.activeTable.rows.value,
        this.activeTable.revision.value,
        this.activeTable.loading.value,
        this.activeTable.capped.value,
        this.activeTable.totalCount.value,
        this.activeTable.error.value
      ],
      () => this.syncLive(),
      { deep: !0, immediate: !0 }
    ));
  }
  syncLive() {
    const r = this.activeTable;
    if (r) {
      if (r.error.value) {
        this._errors.value = [{
          code: r.error.value.code,
          message: r.error.value.message
        }], this._isLoading.value = !1, this._allLoaded.value = !0;
        return;
      }
      this.tableHeaders.value = [...r.columns.value], this._rows.value = r.rows.value.map((t) => {
        const o = [...t.values];
        return {
          key: this.rowKey(this.toRecord(o)),
          values: o
        };
      }), this._isLoading.value = r.loading.value, this._totalCount.value = r.totalCount.value ?? r.rows.value.length, this._capped.value = r.capped.value, this._allLoaded.value = !r.loading.value;
    }
  }
  disposeLiveQuery() {
    var r, t;
    (r = this.stopLiveWatch) == null || r.call(this), this.stopLiveWatch = void 0, (t = this.activeTable) == null || t.dispose(), this.activeTable = void 0, this._capped.value = !1;
  }
  getRowHue(r) {
    var t, o;
    return (o = (t = this.options).rowHue) == null ? void 0 : o.call(t, this.toRecord(r.values));
  }
  rowKey(r) {
    return typeof this.options.rowKey == "function" ? this.options.rowKey(r) : Object.values(r)[0];
  }
  async loadMore() {
    if (this._live.value || this.allLoaded.value || !this.lastCursor || this.abortController)
      return;
    const r = { ...this.currentQuery };
    this._errors.value = [], this.abortController = new AbortController(), r.after = this.lastCursor;
    try {
      const t = await this.graph.queryTable(r, this.abortController.signal);
      t.rows.length === 0 ? this._allLoaded.value = !0 : (this._rows.value.push(...t.rows.map((o) => ({
        key: this.rowKey(this.toRecord(o)),
        values: o
      }))), this.lastCursor = t.cursors.last);
    } catch (t) {
      this._errors.value = t;
    } finally {
      this.abortController = void 0;
    }
  }
  buildQuery(r, t, o = "", n = !1) {
    var P;
    if (r.edge === void 0)
      return;
    const i = (o ? o + "." : "") + r.edge, s = t[r.edge];
    if (s === void 0) {
      Q.err(`Attempted to query edge '${r.edge}' which was not found`);
      return;
    }
    const l = this.graphMeta[s.node], m = this.columnState.value.filter((c) => c.queryPath.join(".") === i && // Ignore columns that doesn't exist, this can happen if a field has been removed from the graph
    l.fields[c.field]), p = [];
    typeof r.filter == "string" && r.filter.trim().length > 0 && p.push(r.filter);
    for (const c of m) {
      const de = c.queryPath.join(".") + "@" + c.field, w = l.fields[c.field];
      if (!w)
        continue;
      const H = this.state.value.filters[de];
      if (!H)
        continue;
      const q = [], z = [], I = [], W = [];
      for (const S of H)
        if (S.type) {
          const g = S;
          switch (g.type) {
            case "all":
              z.push(g.value);
              break;
            case "any":
              q.push(g.value);
              break;
            case "not":
              I.push(g.value);
              break;
          }
        } else {
          const g = S;
          W.push(g);
        }
      if (w.valueType.type === "array") {
        let S = function(C) {
          const d = w.valueType.type === "array" && w.valueType.itemType.type === "scalar" && w.valueType.itemType.scalarType === "string", f = w.valueType.type === "array" && w.valueType.itemType.type === "enum";
          if (!d && !f)
            throw new Error("Unsupported type: " + JSON.stringify(w, null, 2));
          const M = [];
          for (const fe of C)
            M.push(`'${N(fe)}'`);
          return M;
        }, g = S(z);
        g.length > 0 && p.push(`${c.field} allof [${g.join(",")}]`), g = S(q), g.length > 0 && p.push(`${c.field} anyof [${g.join(",")}]`), g = S(I), g.length > 0 && p.push(`not(${c.field} anyof [${g.join(",")}])`);
      } else {
        let S = function(d) {
          if (w.filter.type === "instantRange")
            return `${c.field} >= ${d.from.toISOString()} and ${c.field} < ${d.to.toISOString()}`;
          if (w.filter.type === "numericRange")
            return d.from === d.to ? `${c.field} == ${d.from}` : d.to === Number.MAX_VALUE ? `${c.field} >= ${d.from}` : d.from === Number.MIN_VALUE ? `${c.field} <= ${d.to}` : `${c.field} >= ${d.from} and ${c.field} <= ${d.to}`;
          let f = w.valueType;
          if (w.valueType.type === "array" && (f = w.valueType.itemType), f.type === "scalar" && f.scalarType === "boolean")
            return `${c.field} == ${d ? "true" : "false"}`;
          if (f.type === "scalar" && f.scalarType === "uuid")
            return `${c.field} == ${d}`;
          if (f.type === "enum")
            return `${c.field} == '${N(d)}'`;
          if (f.type === "scalar" || f.type === "dynamicFields")
            return d ? `${c.field} == '${N(d)}'` : `(${c.field} == '' or ${c.field} == nothing)`;
        };
        const g = [], C = [];
        for (const d of z) {
          const f = S(d);
          f !== void 0 && p.push(f);
        }
        for (const d of q) {
          let f = w.valueType;
          if (f.type === "scalar" && f.scalarType === "boolean")
            C.push(d ? "true" : "false");
          else if (f.type === "scalar" && f.scalarType === "uuid")
            C.push(d);
          else if (f.type === "enum")
            C.push(`'${d}'`);
          else if (f.type === "scalar" || f.type === "dynamicFields")
            d || (C.push("''"), C.push("nothing")), C.push(`'${N(d)}'`);
          else {
            const M = S(d);
            M !== void 0 && g.push(M);
          }
        }
        for (const d of I) {
          const f = S(d);
          f !== void 0 && p.push(`not (${f})`);
        }
        for (const d of W) {
          const f = S(d);
          f !== void 0 && p.push(f);
        }
        g.length > 0 && p.push(`(${g.join(" or ")})`), C.length > 0 && p.push(`${c.field} anyof [${C.join(",")}]`);
      }
    }
    const v = m.map((c) => c.field), A = l.idField;
    if (!n && v.indexOf(A) === -1 && v.splice(0, 0, A), !n && r.dataFields)
      for (const c of r.dataFields)
        v.indexOf(c) === -1 && v.push(c);
    let j;
    o || (this.state.value.orderBy !== void 0 ? j = `${this.state.value.orderBy.field} ${this.state.value.orderBy.direction}` : j = r.orderBy);
    let k = !1;
    o && this.state.value.orderBy !== void 0 && (k = !0);
    const F = {
      edge: r.edge,
      require: k || p.length > 0 ? "some" : "any",
      orderBy: j,
      count: o.length === 0 ? U : !1,
      node: {
        fields: v,
        navigate: (P = r.navigations) == null ? void 0 : P.map(
          (c) => this.buildQuery(c, l.edges, i)
        ).filter((c) => c !== void 0)
      },
      filter: p.length > 0 ? `(${p.join(") and (")})` : void 0,
      phrase: r.phrase
    };
    return s.cardinality === "many" && (F.limit = o === "" ? 100 : 1e3), F;
  }
  toRecord(r) {
    return this.tableHeaders.value.reduce((t, o, n) => (t[o] = r[n], t), {});
  }
  getNodeMeta(r, t) {
    const o = r[0], n = t[o];
    if (n)
      return r.length > 1 ? this.getNodeMeta(r.slice(1), this.graphMeta[n.node].edges) : this.graphMeta[n.node];
  }
  addColumn(r) {
    const [t, o] = r.key.split("@");
    this.columnState.value.push({
      field: o,
      queryPath: t.split(".")
    }), this.refreshInternal(!0);
  }
  removeColumn(r) {
    const t = this.columnState.value.findIndex((o) => o.queryPath.join(".") + "@" + o.field === r.key);
    t !== -1 && this.columnState.value.splice(t, 1);
  }
  setColumnOrder(r, t) {
    const o = this.columns.value.findIndex((i) => i.key === r.key);
    if (o < 0)
      return;
    const n = this.columnState.value.splice(o, 1);
    t > o && (t -= 1), this.columnState.value.splice(t, 0, ...n);
  }
  setColumnSize(r, t) {
    const o = this.columnState.value.find((n) => n.queryPath.join(".") + "@" + n.field === r);
    o && (o.size = t);
  }
  setFilters(r, t) {
    t ? this.state.value.filters[r.key] = t : delete this.state.value.filters[r.key];
  }
  setSort(r, t) {
    const [o, n] = r.key.split("@");
    t ? this.state.value.orderBy = {
      field: n,
      queryPath: o.split("."),
      direction: t
    } : this.state.value.orderBy = void 0;
  }
  updateRow(r, t) {
    const o = this._rows.value.find((i) => i.key === r);
    if (!o) return !1;
    let n = !1;
    for (const [i, s] of Object.entries(t)) {
      const l = this.tableHeaders.value.indexOf(i);
      l >= 0 && !n && o.values[l] !== s && (o.values[l] = s, n = !0);
    }
    return n && (o.version = Date.now()), !0;
  }
}
function N(e) {
  return e == null ? void 0 : e.replaceAll("'", "''");
}
const ut = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d+)?(?:Z|\+00:00)$/, ct = /^\d{4}-\d{2}-\d{2}$/;
function dt(e) {
  return V(e) ?? "null";
}
function ft(e, r = {}) {
  return JSON.parse(e, ce(r));
}
function ce(e = {}) {
  return (r, t) => {
    if (typeof t == "number")
      return new x(t);
    if (typeof t == "string") {
      if (ut.test(t))
        return new Date(t);
      if (ct.test(t))
        return ne.parse(t);
    }
    return e.graph && typeof t == "object" && t !== null && Array.isArray(t.nodes) ? t.nodes : t;
  };
}
function V(e) {
  if (e == null)
    return e === null ? "null" : void 0;
  if (e instanceof x || x.isDecimal(e))
    return e.toString();
  switch (typeof e) {
    case "number":
      return Number.isFinite(e) ? String(e) : "null";
    case "boolean":
      return e ? "true" : "false";
    case "bigint":
      return e.toString();
    case "string":
      return JSON.stringify(e);
    case "function":
    case "symbol":
      return;
  }
  if (typeof e.toJSON == "function")
    return V(e.toJSON());
  if (Array.isArray(e))
    return `[${e.map((o) => V(o) ?? "null").join(",")}]`;
  const r = [];
  for (const t in e) {
    if (!Object.prototype.hasOwnProperty.call(e, t))
      continue;
    const o = V(e[t]);
    o !== void 0 && r.push(`${JSON.stringify(t)}:${o}`);
  }
  return `{${r.join(",")}}`;
}
const qt = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  createReviver: ce,
  deserialize: ft,
  serialize: dt
}, Symbol.toStringTag, { value: "Module" }));
function zt() {
  return b("$portal_queryExporter", {})();
}
class B extends Promise {
  /**
   * Will run callback if the command is the specified type.
   * 
   * ```
   * await matchType(command)
   *   .is(orderCommands.updateRowQuantity, async c => {
   *     console.log(c.rowId);
   *   })
   *   .is(orderCommands.addOrderTag, async c => {
   *     console.log(c.tagNumber)
   *   })
   * ```
   * 
   * @param command 
   * @param callback 
   */
  is(r, t) {
    return new B((o) => {
      this.then((n) => {
        if (yt(n, r)) {
          t(n).then(() => o(this));
          return;
        }
        o(this);
      });
    });
  }
}
function u(e) {
  return { type: e };
}
function yt(e, r) {
  return e.type === r.type;
}
function It(e) {
  return new B((r) => {
    r(e);
  });
}
const Kt = {
  updateRowQuantity: u("UpdateRowQuantity"),
  addOrderTag: u("AddOrderTag"),
  removeOrderTag: u("RemoveOrderTag"),
  addDeliveryTag: u("AddDeliveryTag"),
  removeDeliveryTag: u("RemoveDeliveryTag"),
  addDelivery: u("AddDelivery"),
  upsertDeliveryField: u("UpsertDeliveryField"),
  addRow: u("AddRow"),
  upsertRowField: u("UpsertRowField"),
  updateRowLostQuantity: u("UpdateRowLostQuantity"),
  addActivityLog: u("AddActivityLog"),
  setDeliveryAddress: u("SetDeliveryAddress"),
  setBillingAddress: u("SetBillingAddress"),
  updateRmaRowQuantity: u("UpdateRmaRowQuantity"),
  upsertRmaRowField: u("UpsertRmaRowField"),
  upsertRmaRowExchange: u("UpsertRmaRowExchange"),
  setRmaRowApproval: u("SetRmaRowApproval"),
  completeRma: u("CompleteRma"),
  setDeliveryAsProcessing: u("MarkDeliveryAsPicked"),
  setDeliveryAsReleased: u("MarkDeliveryAsShipped"),
  cancelDelivery: u("CancelDelivery"),
  setRmaRowReference: u("UpdateRmaRowReference"),
  addOrUpdateRmaAdjustment: u("AddOrUpdateRmaAdjustment"),
  upsertRmaAdjustmentField: u("UpsertRmaAdjustmentField"),
  removeRmaAdjustment: u("RemoveRmaAdjustment"),
  addOrUpdateAdjustment: u("AddOrUpdateAdjustment"),
  upsertAdjustmentField: u("UpsertAdjustmentField"),
  removeAdjustment: u("RemoveAdjustment"),
  rebalancePayments: u("RebalancePayments"),
  upsertOrderField: u("UpsertOrderField"),
  updateDeliveryPrice: u("UpdateDeliveryPrice"),
  cancelOrder: u("CancelOrder"),
  /**
   * @deprecated Legacy dependency. Will be removed.
   */
  updateVoucherCode: u("UpdateVoucherCode")
}, pt = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null
}, Symbol.toStringTag, { value: "Module" })), mt = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null
}, Symbol.toStringTag, { value: "Module" })), ht = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null
}, Symbol.toStringTag, { value: "Module" })), vt = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null
}, Symbol.toStringTag, { value: "Module" })), gt = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null
}, Symbol.toStringTag, { value: "Module" })), Ut = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Asset: gt,
  Order: pt,
  Payment: mt,
  Sku: ht,
  Ticket: vt
}, Symbol.toStringTag, { value: "Module" })), Jt = /* @__PURE__ */ J({
  __name: "Authorize",
  props: {
    patterns: {}
  },
  setup(e) {
    const { user: r } = ie();
    return (t, o) => he(r).authorizeAll(e.patterns) ? G(t.$slots, "default", { key: 0 }) : G(t.$slots, "denied", { key: 1 }, () => [
      o[0] || (o[0] = T("div", { class: "authorize--no-permission" }, " No permission ", -1))
    ]);
  }
});
export {
  Jt as Authorize,
  Ut as Commands,
  se as CurrencyDisplay,
  qt as HanteraJson,
  Re as appContextKey,
  Ot as apps,
  je as backendApiKey,
  Ae as contextKey,
  Me as contextKeys,
  Mt as formatting,
  ke as hostKey,
  Lt as legacyInvoiceKey,
  Ct as legacyModeKey,
  Kt as legacyOrderCommands,
  $t as legacyOrderKey,
  Tt as legacyRmaKey,
  xt as legacyRmaRowKey,
  Q as log,
  It as matchType,
  Fe as processesKey,
  yt as sameType,
  Rt as useAppContext,
  ie as useBackendApi,
  At as useContext,
  Ft as useDialogs,
  Ee as useEnums,
  Pt as useEvents,
  Qt as useGraphDataProvider,
  De as useGraphMeta,
  jt as useHost,
  it as useLiveQueries,
  nt as useLocalization,
  Dt as useOrderViewContext,
  kt as usePhrases,
  Et as useProcesses,
  zt as useQueryExporter,
  st as useRegistry,
  Nt as useResolveLabel,
  Vt as viewContexts
};
